import React, { useCallback, useState } from 'react'
import ReactFlow, { addEdge, ReactFlowProvider, useNodesState } from 'react-flow-renderer'
import { Sidebar } from './sidebar/Sidebar';

export const Flow = ({initialEdge, initialNode, styleFlow, disablePanOnDrag = false, disableZoomOnScroll = false, disablePanOnScroll = false}) => {
    
    const [edges, setEdges, onEdgesChange] = useNodesState(initialEdge);
    const [nodes, setNodes, onNodesChange] = useNodesState(initialNode);
    const [panOnDrag, setpanOnDrag] = useState(disablePanOnDrag);
    const [zoomOnScroll, setZoomOnScroll] = useState(disableZoomOnScroll);
    const [panOnScroll, setPanOnScroll] = useState(disablePanOnScroll);
    const [zoomOnDoubleClick, setZoomOnDoubleClick] = useState(false);
    const [isDraggable, setIsDraggable] = useState(false);


    const onConnect = useCallback((params) => setEdges((els)=> addEdge(params, els)), []);
  
  
    return (
        <div className='reactflow-wrapper'>
            <ReactFlowProvider>
                <div className='row'>
                    <div className='col-12 col-md-11'>
                        <ReactFlow 
                            nodes={nodes}
                            edges={edges}
                            onNodesChange={onNodesChange}
                            onEdgesChange={onEdgesChange}
                            onConnect={onConnect}           
                            className="touchdevice-flow"
                            style={styleFlow}
                            panOnDrag={panOnDrag}
                            zoomOnScroll={zoomOnScroll}
                            panOnScroll={panOnScroll}
                            zoomOnDoubleClick={zoomOnDoubleClick}
                            nodesDraggable={isDraggable}

                        >
                        </ReactFlow>
                    </div>
                    <div className='col-12 col-md-1'>
                        <Sidebar />
                    </div>
                </div>

            </ReactFlowProvider>
        </div>
    )
}
